module.exports = __webpack_public_path__ + "img/print_24px_rounded.fa52c0a8.svg";